// extracted by mini-css-extract-plugin
export default {"app-gallery":"_fbb3md","appGallery":"_fbb3md"};